import { wrapperRequest } from './utils';
import { API_URL } from './consts';

export const fetchApps = () => wrapperRequest({ url: `${API_URL}/apps?expand=payload&expand=kpis` });
